
import { AloDbGlider, IAloDbGliderConstParam } from '@/models/alodb/AloDbGlider';
import { FilterGlider } from '@/models/filter/FilterGlider';
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer';
import { INextSurfacingDoConfig } from '@/models/iris/nextSurfacing/INextSurfacingDoConfig';
import { IFileTransfertConfig } from '@/models/iris/fileTransfert/IFileTransfertConfig';
import { ISingleWayPointConfig } from '@/models/iris/singleWayPoint/ISingleWayPointConfig';
import { IExpectedNMEAConfig } from '@/models/iris/expectedNMEA/IExpectedNMEAConfig';
import { IFtpConfig } from '@/models/iris/ftp/IFtpConfig';
import { IRsyncConfig } from '@/models/iris/rsync/IRsyncConfig';

export interface IGliderState {
    status:string
    gliders: Array<AloDbGlider>
    modifiedAdmGlider: AloDbGlider
    originalAdmGlider: AloDbGlider
    gliderLoading:boolean    
    nsdLoading:boolean    
    fileTransfertLoading:boolean    
    singleWayPointLoading:boolean    
    ftpLoading:boolean    
    rsyncLoading:boolean    
    expectedNMEALoading:boolean    
    adminFilter: FilterGlider
    originalNsdConfigs: { [index:number]:IrisConfigContainer<INextSurfacingDoConfig>}
    modifiedNsdConfigs: { [index:number]:IrisConfigContainer<INextSurfacingDoConfig>}
    originalFileTransfertConfigs: { [index:number]:IrisConfigContainer<IFileTransfertConfig>}
    modifiedFileTransfertConfigs: { [index:number]:IrisConfigContainer<IFileTransfertConfig>}    
    originalSingleWayPointConfigs: { [index:number]:IrisConfigContainer<ISingleWayPointConfig>}
    modifiedSingleWayPointConfigs: { [index:number]:IrisConfigContainer<ISingleWayPointConfig>}
    originalExpectedNMEAConfigs: { [index:number]:IrisConfigContainer<IExpectedNMEAConfig>}
    modifiedExpectedNMEAConfigs: { [index:number]:IrisConfigContainer<IExpectedNMEAConfig>}
    originalFtpConfigs: { [index:number]:IrisConfigContainer<IFtpConfig>}
    modifiedFtpConfigs: { [index:number]:IrisConfigContainer<IFtpConfig>}
    originalRsyncConfigs: { [index:number]:IrisConfigContainer<IRsyncConfig>}
    modifiedRsyncConfigs: { [index:number]:IrisConfigContainer<IRsyncConfig>}
    
}
  
const state:IGliderState = { 
    status: '',
    gliders: [],
    modifiedAdmGlider: new AloDbGlider(),
    originalAdmGlider: new AloDbGlider(),
    gliderLoading:false,
    nsdLoading:false,
    singleWayPointLoading:false,
    ftpLoading:false,
    rsyncLoading:false,
    fileTransfertLoading:false,
    expectedNMEALoading:false,
    adminFilter: new FilterGlider(),
    originalNsdConfigs: {} as { [index:number]:IrisConfigContainer<INextSurfacingDoConfig>},
    modifiedNsdConfigs: {} as { [index:number]:IrisConfigContainer<INextSurfacingDoConfig>},
    originalFileTransfertConfigs: {} as { [index:number]:IrisConfigContainer<IFileTransfertConfig>},
    modifiedFileTransfertConfigs: {} as { [index:number]:IrisConfigContainer<IFileTransfertConfig>},
    originalSingleWayPointConfigs: {} as { [index:number]:IrisConfigContainer<ISingleWayPointConfig>},
    modifiedSingleWayPointConfigs: {} as { [index:number]:IrisConfigContainer<ISingleWayPointConfig>},    
    originalExpectedNMEAConfigs:{} as  { [index:number]:IrisConfigContainer<IExpectedNMEAConfig>},
    modifiedExpectedNMEAConfigs:{} as  { [index:number]:IrisConfigContainer<IExpectedNMEAConfig>},
    originalFtpConfigs:{} as  { [index:number]:IrisConfigContainer<IFtpConfig>},
    modifiedFtpConfigs:{} as  { [index:number]:IrisConfigContainer<IFtpConfig>},
    originalRsyncConfigs:{} as  { [index:number]:IrisConfigContainer<IRsyncConfig>},
    modifiedRsyncConfigs:{} as  { [index:number]:IrisConfigContainer<IRsyncConfig>}
}
  
export default state